var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9e2d8d9b0a8d40a5b2e25eda1916fb5f7c217f95"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kelp-dapp@staderlabs"]={id:"9e2d8d9b0a8d40a5b2e25eda1916fb5f7c217f95"};
      